import { createSlice } from '@reduxjs/toolkit';

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    total: 0,
  },
  reducers: {
    addItem: (state, action) => {
      const existingItem = state.items.find(item => item.id === action.payload.id);
      
      if (!existingItem) {
        state.items.push({
          ...action.payload,
          price: Number(action.payload.price) || 0,
          quantity: 1
        });
      }
      
      // Recalculate total
      state.total = Number(
        state.items.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toFixed(2)
      );
    },
    removeItem: (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
      state.total = Number(
        state.items.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toFixed(2)
      );
    },
    updateQuantity: (state, action) => {
      const item = state.items.find(item => item.id === action.payload.id);
      if (item) {
        item.quantity = action.payload.quantity;
        if (item.quantity <= 0) {
          state.items = state.items.filter(i => i.id !== action.payload.id);
        }
        state.total = Number(
          state.items.reduce((sum, item) => sum + (Number(item.price) || 0), 0).toFixed(2)
        );
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.total = 0;
    },
  },
});

export const { addItem, removeItem, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;